import styled from "styled-components";

export const ContainerPagina = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;

  table {
    line-height: 16px;

    tr.tituloSecao {
      display: grid;
      grid-template-columns: 80% 20%;
      justify-content: space-between;
      font-size: 14px;
      border: none;
      margin-bottom: 4px;

      &.comSubtitulo {
        display: flex;
        grid-template-columns: none;
      }

      td {
        width: 100%;
        padding: 0;
      }

      * {
        font-size: 14px;
        line-height: 16px;
        border: none;
      }

      table {
        width: 100%;

        tbody {
          display: grid;
          grid-template-columns: 80% 20%;

          tr + tr {
            display: flex;
            align-items: flex-end;

            td {
              text-align: right;
            }
          }

          tr.subtituloSecao {
            display: flex;
            flex-direction: column;
            td {
              border: 1px solid black;
              font-size: 10px;
              text-align: left;
              padding: 4px;

              * {
                font-size: 10px;
              }

              &:nth-child(1) {
                border: none;
                display: grid;
                grid-template-columns: 60% 20% 20%;
                margin-bottom: 4px;
                padding: 0;

                span {
                  border: 1px solid black;
                  padding: 4px;

                  & + span {
                    border-left: none;
                  }
                  :nth-child(3) {
                    text-align: right;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FormFiltros = styled.form`
  width: 500px;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  justify-content: left;
  align-items: flex-start;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
  }

  div {
    display: flex;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 100%;
    column-gap: 15px;
    flex-direction: row-reverse;
    gap: 12px;

    &.filtros {
      flex-direction: row;
    }
    button {
      span,
      span * {
        font-size: 16px;
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    width: 100%;
    div {
      justify-content: start;
    }
    div.filtros {
      flex-direction: column;
      width: 95%;
    }
  }
`;

export const AreaInfo = styled.table`
  width: 750px;
  margin: 5px auto;
  border: 1px solid black;
  padding: 8px 12px;

  tr.cabecalhoDoc {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 95px;

    .infoCabecalho {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: right;
      gap: 8px;

      h2 {
        font-size: 1.2rem;
        height: 1.4rem;
      }
    }
    img {
      height: 95%;
    }
  }

  tr.infoRelatorio {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }
`;

export const TabelaConteudo = styled.table`
  width: 750px;
  border: 1px solid black;
  tbody {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  tr {
    padding: 0;
    display: grid;
    grid-template-columns: 2fr 5fr 2fr 4fr 3fr 2fr 40px;
    text-align: center;
    align-items: center;
    height: 100%;
    border-bottom: 1px solid black;

    &:last-child {
      border-bottom: none;
    }

    &.cabecalho {
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      font-weight: bold;
    }
    &.cabecalhoContrato {
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      font-weight: bold;
      display: flex;
      grid-template-columns: none;
    }
    &.rodape {
      font-weight: bold;
      grid-template-columns: 2.18fr 1fr;
      padding: 0 4px;

      td:first-child {
        text-align: left;
      }
      td:last-child {
        text-align: right;
      }
    }
    &.itemLista {
      /* padding: 4px 12px; */
      td {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    }
    .center {
      text-align: center;
    }
    td,
    td span {
      border-right: 1px solid black;
      font-size: 0.85rem;
      padding: 2px 0;

      &:last-child {
        border-right: none;
      }
    }
    .acoesProcedimento {
      display: flex;
      align-items: center;
      justify-content: space-around !important;

      span {
        border: none;
        font-size: unset;
        padding: 0;
        height: 100%;
        padding: 2px;
        cursor: pointer;
        border-radius: 4px;
      }

      .editButon {
        background-color: #08f1;
        transition-duration: 0.4s;
        svg {
          fill: ${({ theme }) => theme.colors.success};
        }
      }
      .deleteButon {
        transition-duration: 0.4s;
        background-color: #f001;
        svg {
          fill: ${({ theme }) => theme.colors.error};
        }
      }
      .editButon:hover {
        background-color: #08f3;
      }
      .deleteButon:hover {
        background-color: #f003;
      }
    }
  }
`;
